import { Student } from '../types/inviteStudentsTypes';

export const trimForPost = (students: Student[]): Student[] =>
    students.map((student) => ({
        firstName: student.firstName.trim(),
        lastName: student.lastName.trim(),
        email: student.email.trim(),
        role: student.role
    }));
